import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HERO_IMAGE } from "@/lib/constants";

export default function ProductHero({ code, name, headline, sub, image }) {
  return (
    <section className="relative border-b border-[rgba(255,255,255,0.08)] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={image || HERO_IMAGE}
          alt={name}
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050607] via-[#050607]/80 to-[#050607]/40" />
        <div className="absolute inset-0 grid-overlay opacity-30" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-24 md:pt-36 md:pb-32">
        <div className="overline">{code} · PINE SYSTEMS</div>
        <h1 className="font-display text-5xl md:text-7xl uppercase mt-4 max-w-4xl leading-[1.02] text-white">
          {name}
        </h1>
        <h2 className="font-display text-xl md:text-2xl uppercase mt-6 max-w-3xl text-[#AEB7B7] leading-snug">
          {headline}
        </h2>
        {sub && (
          <p className="text-[#AEB7B7] text-base md:text-lg mt-6 max-w-2xl leading-relaxed">
            {sub}
          </p>
        )}
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/standort-pruefen" className="btn-primary" data-testid="product-cta-primary">
            Standortpotenzial prüfen <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
          <Link to="/systeme" className="btn-secondary" data-testid="product-cta-secondary">
            Alle Systeme
          </Link>
        </div>
      </div>
    </section>
  );
}
